<div class="table mb-0100 pb-0050">
  <div class="tr tr--noGutter tile__heading flexJustify--between">
    <div>Tasks</div>
  </div>

  <div *ngFor="let task of orderedTasks"
       class="task-row tr tr--noGutter border-0 flexJustify--stretch">
    <div class="w-100">
      <h4>
        <!-- Icon for task type -->
        <i class="far fa-fw spacerRight color--green--002"
           [ngClass]="getTaskIconClass(task.actionPurpose)"></i>
        <!-- Link if task exists -->
        <a *ngIf="task.action?.id"
           class="link link--noline"
           (click)="viewTask(task)">
          <span class="txt-fw-700">{{ getTaskDisplayLabel(task.actionPurpose) }}</span>
        </a>
        <!-- Label if task doesn't exist -->
        <span *ngIf="!task.action?.id">{{ getTaskDisplayLabel(task.actionPurpose)}}
          <!-- Ability to add if not scheduled -->
          <button type="button"
                  *ngIf="task.scheduleCreateDaysBeforeEventStart === null && canEditOrCreateTask(task)"
                  class="link link--noline"
                  title="Add {{ getTaskDisplayLabel(task.actionPurpose) }} task"
                  (click)="openTaskDialog(task)"><i class="fas fa-circle-plus spacerLeft"></i></button>
        </span>
        <!-- Tooltip -->
        <i class="far fa-info-circle color--gray--009 float-r"
           #taskTooltip="matTooltip"
           (click)="taskTooltip.toggle()"
           [matTooltip]="getTaskTooltipText(task)"></i>
      </h4>
      <div *ngIf="task.scheduleCreateDaysBeforeEventStart !== null && task.action == null"
           class="d-flex">
        <ng-container *ngIf="canEditOrCreateTask(task)">
          <a class="txt-14 link link--small scheduled-task-info"
             (click)="openTaskDialog(task)">
            {{ getScheduledTaskDate(task.scheduleCreateDaysBeforeEventStart) | date:'MMMM d' }}
            <span *ngFor="let text of getTaskScheduleStrings(task.scheduleCreateDaysBeforeEventStart)">
              {{text}}
            </span>
          </a>
        </ng-container>
        <ng-container *ngIf="!canEditOrCreateTask(task)">
          <span class="txt-14 scheduled-task-info"
                (click)="openTaskDialog(task)">
            {{ getScheduledTaskDate(task.scheduleCreateDaysBeforeEventStart) | date:'MMMM d' }}
            <span *ngFor="let text of getTaskScheduleStrings(task.scheduleCreateDaysBeforeEventStart)">
              {{text}}
            </span>
          </span>
        </ng-container>
      </div>
    </div>
  </div>
</div>
